export const SUCCESS_MESSAGE = 'SUCCESS';
export const PHONE_TAKEN = 'PHONE_TAKEN';
export const NOT_FOUND = '1002';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const OFFLINE_RETRY_TIMES = 5;
